module.exports = __webpack_public_path__ + "static/gallery5-e089c383c2845b0021e180ed74a0bffb.jpg";